import './input.min.js'
import './toast.js'
import './popover.js'
import './combobox.js'
import './collapse.js'
import './accordion.js'
import {hxConfirm} from './confirm.js'
import {getEl, getAllEl, domIsSettled, removeElementByID, formatNumber} from './dom.js'
import {db} from './db.js'

window.db = db
window.hxConfirm = hxConfirm
window.removeElementByID = removeElementByID

window.$ = getEl
window.$$ = getAllEl
window.formatNumber = formatNumber


window.openDialog = openDialog
export function openDialog(id) {
	domIsSettled().then(() => {
		const $el = document.querySelector(`#${id}`)
		if ($el) {
			$el.showModal()
		}
	})
}
